export const SET_DESTINATION_INFOGRAPHIC = 'SET_DESTINATION_INFOGRAPHIC';

export const setDestinationInfographic = (payload) => {
    return {
        type: SET_DESTINATION_INFOGRAPHIC,
        payload,
    };
};
